import styled from "@emotion/styled";

export const HeaderImageWrapper = styled.img`
  height: ${({ height }) => height || "80px"};
  width: auto;

  @media (max-width: 1024px) {
    height: ${({ height }) => `calc(${height || "80px"} * 0.8)`}; // 80% of original
  }

  @media (max-width: 768px) {
    height: ${({ height }) => `calc(${height || "80px"} * 0.6)`}; // 60% of original
  }

  @media (max-width: 480px) {
    height: ${({ height }) => `calc(${height || "80px"} * 0.5)`}; // 50% of original
  }
`;
